"use client";
import React, { useEffect, useState, useContext, useRef } from 'react';
import { sanitize } from '../../utils/sanitizeHtml';
import { useTranslation } from 'react-i18next';
import { dbLabel } from '../../i18n/dbLabels';
import { app } from "@microsoft/teams-js";
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { removefromCompletedApi, removeBookMarkApi, userBookMarkApi, postInProgressApi, postCompletedApi, recomendationId, postVideoProgressApi } from '../../apis/WebServices';
import { computeMilestone } from './videoProgress';
import useVideos from '../../hooks/useVideos';
import VideoCatalogue from '../../services/VideoCatalogue';
import { homeDeepLink, imageEndPoint } from '../../apis/env';
import { Link } from 'react-router-dom';
import Loader from '../loader/Loader';
import { Pagination } from 'antd';
import { message } from 'antd';
import oopsimg from "../../assets/oops-img.png"
import { UserContext } from '../../contexts/UserContext';
import nutritionImg from "../../assets/nutrition-blue.png"
import trainingImg from "../../assets/training-blue.png"
import lifestleImg from "../../assets/lifestyle.png"



const VideoDetail = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [vdoDetail, setVdoDetail] = useState('');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const videoId = queryParams.get("videoId");
    const vId = queryParams.get("vId");
    const [catgId, setCatgId] = useState(0);
    const [relatedVideos, setRelatedVideos] = useState([])
    const [loading, setLoading] = useState(true)
    const [showModel, setShowModel] = useState(false)
    const [vdoId, setVdoId] = useState(videoId)
    const [currentVideoId, setCurrentVideoId] = useState('');
    const [page, setPage] = useState(1);
    const [videoCategoryId, setVideoCategroyId] = useState(vId)
    const { userName, setUserName, userToken } = useContext(UserContext)
    const [tabSwitch, setTabSwitch] = useState(false);
    const [allVideos, setAllVideos] = useState([]);
    const limit = 12
    const [BookMarkedTrueIds, setAllBookMarkedTrueIds] = useState([]);
    const [disabled, setDisabled] = useState(false)
    const [tabTracking, setTabTracking] = useState(0);
    const [bookMarkedStatus, setBookMarkedStatus] = useState(false)
    const [bookmarkLoadingIds, setBookmarkLoadingIds] = useState([]);

    // --- Video watch-progress instrumentation (spec §4). Strictly additive & null-guarded:
    // must never throw / break playback. Reports milestones once each + flushes on close.
    const videoElRef = useRef(null);
    const reportedMilestoneRef = useRef(0);   // highest milestone already reported for this video
    const lastPctRef = useRef(0);             // last computed integer percent (for the close flush)
    const lastSecsRef = useRef(0);

    // Reset progress trackers whenever the open video changes.
    useEffect(() => {
        reportedMilestoneRef.current = 0;
        lastPctRef.current = 0;
        lastSecsRef.current = 0;
    }, [vdoId, showModel]);

    const handleVideoTimeUpdate = () => {
        const el = videoElRef.current;
        if (!el || !userToken || !vdoId || !Number.isFinite(el.duration) || el.duration <= 0) return;
        const fraction = el.currentTime / el.duration;
        lastPctRef.current = Math.min(100, Math.round(fraction * 100));
        lastSecsRef.current = Math.round(el.currentTime);
        const milestone = computeMilestone(fraction);
        if (milestone > reportedMilestoneRef.current) {
            reportedMilestoneRef.current = milestone;
            try { postVideoProgressApi(vdoId, milestone, lastSecsRef.current); } catch (_) {}
        }
    };

    const handleVideoEnded = () => {
        if (!userToken || !vdoId) return;
        reportedMilestoneRef.current = 100;
        lastPctRef.current = 100;
        try { postVideoProgressApi(vdoId, 100, lastSecsRef.current); } catch (_) {}
    };

    // Flush the final observed % when the modal closes (covers a partial watch).
    const flushVideoProgress = () => {
        if (!userToken || !vdoId || lastPctRef.current <= 0) return;
        try { postVideoProgressApi(vdoId, lastPctRef.current, lastSecsRef.current); } catch (_) {}
    };


    // Use clean video service for all videos
    const { 
        data: allVideoData, 
        loading: allVideoLoading, 
        fetchData: fetchAllVideos 
    } = useVideos('list', {
        userId: userToken,
        pageSize: 10000,
        pageNumber: 1
    });
    
    // Process all videos when data changes
    useEffect(() => {
        if (allVideoData?.videos) {
            console.log('🎞️ VideoDetail: Loaded all videos for fallback view');
            
            const filteredVideos = allVideoData.videos;
            
            // Extract bookmark IDs using clean service
            const bookmarkedIds = VideoCatalogue.extractBookmarkIds(allVideoData.videos);
            setAllBookMarkedTrueIds(bookmarkedIds);
            
            setAllVideos(filteredVideos);
            setTabTracking(1);
        }
    }, [allVideoData]);

    const handleTabSwitch = (data) => {
        setVdoId(data?.id);
        setVideoCategroyId(data?.category?.id);
        setTabSwitch(true);

    }


    const getQueryParameters = async () => {
        try {
            await app.initialize();
            const context = await app.getContext();
            let searchParams;
            if (window.location.hash.includes("?")) {
                searchParams = new URLSearchParams(window.location.hash.split("?")[1]);
            } else {
                searchParams = new URLSearchParams(window.location.search);
            }

            const paramsObj = {};
            searchParams.forEach((value, key) => {
                paramsObj[key] = value;
            });

            if (context?.subEntityId) {
                paramsObj["subEntityId"] = context.subEntityId;
            }

            if (context?.page?.subPageId) {
                const subPageParams = new URLSearchParams(context.page.subPageId.replace("|", "&"));
                const extractedVideoId = subPageParams.get("videoId");
                const extractedVId = subPageParams.get("vId");

                if (extractedVideoId) setVdoId(extractedVideoId);
                if (extractedVId) setVideoCategroyId(extractedVId);

                paramsObj["videoId"] = extractedVideoId || "";
                paramsObj["vId"] = extractedVId || "";
            }

            if (context?.searchQuery) {
                paramsObj["searchQuery"] = context.searchQuery;
            }

        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
        }
    };


    const handleShowModal = () => {
        if (!userToken) {
            return;
        }

        setShowModel((prev) => !prev);
    }

    const handleCompleted = async (id) => {
        try {
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            setDisabled(true);
            const response = await postCompletedApi(id, userToken);
            if (response.isSuccess) {
                message.success(response?.message)


            }
            else {
                message.error(response?.message)

            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
            fetchVideoDetail()
            setDisabled(false)
        }
    }

    const handleInProgress = async (id) => {
        try {
            await recomendationId(id, userToken);
            const response = await postInProgressApi(id, userToken);
            if (response.isSuccess) {
            }
            else {
                message.error(response?.message)
            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        }
    }

    const handleDeleteBookMark = async (id) => {
        try {
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            setBookMarkedStatus(true)
            setBookmarkLoadingIds(prev => [...prev, id]);
            const response = await removeBookMarkApi(id, userToken);
            if (response?.isSuccess) {

                fetchRelatedVideos(catgId)

                message.success(response?.message)
            }
            else {
                message.error(response?.message)
            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
            setBookMarkedStatus(false)
            setBookmarkLoadingIds(prev => prev.filter(itemId => itemId !== id));
        }
    }


    const handleDeleteCompleted = async (id) => {

        try {
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            setDisabled(true)
            const response = await removefromCompletedApi(id, userToken);
            if (response?.isSuccess) {

                fetchVideoDetail();
                message.success(response?.message)
            }
            else {
                message.error(response?.message)
            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
            setDisabled(false);
        }
    }


    const handleAddBookMark = async (id) => {
        try {
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            setBookMarkedStatus(true)
            setBookmarkLoadingIds(prev => [...prev, id]);

            const response = await userBookMarkApi(id, userToken);
            if (response?.isSuccess) {

                fetchRelatedVideos(catgId)

                message.success(response?.message)

            }
            else {
                message.error(response?.message)

            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
            setBookMarkedStatus(false)
            setBookmarkLoadingIds(prev => prev.filter(itemId => itemId !== id));
        }
    }
    // Use clean video service for video detail
    const { 
        data: videoDetailData, 
        loading: detailLoading, 
        error: detailError,
        fetchData: fetchVideoDetail 
    } = useVideos('detail', {
        videoId: vdoId,
        userId: userToken
    });
    
    // Process video detail when data changes
    useEffect(() => {
        if (videoDetailData) {
            console.log('🎞️ VideoDetail: Loaded video detail:', videoDetailData);
            setCurrentVideoId(videoDetailData.id);
            setVdoDetail(videoDetailData);
            setCatgId(videoDetailData?.category?.id);
            handleTop();
        }
    }, [videoDetailData]);
    
    // 🔧 SECURITY FIX: Trigger fetch when userToken becomes available
    useEffect(() => {
        if (userToken && vdoId && !videoDetailData) {
            console.log('🔄 VideoDetail: userToken available, fetching video detail...', { userToken, vdoId });
            fetchVideoDetail();
        }
    }, [userToken, vdoId, videoDetailData, fetchVideoDetail]);

    // Use clean video service for related videos
    const { 
        data: relatedVideoData, 
        loading: relatedLoading, 
        fetchData: fetchRelatedVideos 
    } = useVideos('related', {
        categoryId: catgId,
        excludeVideoId: vdoId,
        userId: userToken,
        page: page,
        limit: limit
    });
    
    // Process related videos when data changes
    useEffect(() => {
        if (relatedVideoData?.videos) {
            console.log('🎞️ VideoDetail: Loaded', relatedVideoData.videos.length, 'related videos');
            const filteredVideos = relatedVideoData.videos;
            setRelatedVideos(filteredVideos);
        }
    }, [relatedVideoData]);

    const handleTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    useEffect(() => {
        if (showModel) {
            handleInProgress(vdoId);
        }
    }, [showModel, vdoId]);

    useEffect(() => {
        getQueryParameters();
    }, []);

    useEffect(() => {
        setTimeout(() => {
            fetchRelatedVideos();
        }, 500);
    }, [userToken]);

    useEffect(() => {

        const fetchData = async () => {
            try {
                const promises = [
                    fetchVideoDetail()
                ];

                if (videoCategoryId) {
                    promises.push(fetchRelatedVideos(videoCategoryId));
                }

                await Promise.all(promises);
            } catch (error) {
                if (error?.isSuccess === false) {
                    message.error(error?.message);
                } else {
                }
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [videoCategoryId, vdoId]);






    const handleRelatedVideo = async (id, catgryId) => {
        // Keep the URL in sync with the displayed video: the language-change remount
        // (App.jsx key={language}) and browser navigation restore from the URL, so a
        // state-only swap would "lose" the current video (2026-07-11 issue).
        navigate(`/video-detail?videoId=${id}${catgryId ? `&vId=${catgryId}` : ''}`, { replace: false });
        setVdoId(id);
        setVideoCategroyId(catgryId)

    }


    const handleAddBookMarkAllVideos = async (id) => {
        try {
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            setBookMarkedStatus(true)
            setBookmarkLoadingIds(prev => [...prev, id]);
            if (BookMarkedTrueIds.includes(id)) {

                const response = await removeBookMarkApi(id, userToken);

                if (response.isSuccess) {
                    message.success(response?.message)
                    setAllBookMarkedTrueIds((prevTrueIds) => prevTrueIds.filter((itemId) => itemId !== id));
                }
            } else {
                const response = await userBookMarkApi(id, userToken);

                if (response.isSuccess) {
                    message.success(response?.message)
                    setAllBookMarkedTrueIds((prevTrueIds) => [...prevTrueIds, id]);
                }
            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
            setBookMarkedStatus(false)
            setBookmarkLoadingIds(prev => prev.filter(itemId => itemId !== id));
        }
    };


    const handleToggleBookMark = async (id, isBookmark) => {
        try {
            let response;
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            setBookMarkedStatus(true)
            setBookmarkLoadingIds(prev => [...prev, id]);

            if (isBookmark) {
                response = await removeBookMarkApi(id, userToken);
            } else {
                response = await userBookMarkApi(id, userToken);
            }

            if (response?.isSuccess) {
                message.success(response?.message);
                setVdoDetail((prev) => ({ ...prev, isBookmark: !isBookmark }));
                setAllBookMarkedTrueIds((prevTrueIds) =>
                    isBookmark ? prevTrueIds.filter((itemId) => itemId !== id) : [...prevTrueIds, id]
                );
            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
            setBookMarkedStatus(false)
            setBookmarkLoadingIds(prev => prev.filter(itemId => itemId !== id));
        }
    };

    const handleBackClick = () => {
        try {
            console.log('🔄 SMART BACK: Video Detail navigation');
            
            // Check navigation context
            const urlParams = new URLSearchParams(window.location.search);
            const fromParam = urlParams.get('from');
            
            console.log('📍 Video Detail context:', { fromParam });
            
            if (fromParam === 'home') {
                // Came from Home tab - navigate back to Home tab using Teams SDK
                console.log('🏠 Cross-tab navigation: Video Detail -> Home tab');
                if (window.microsoftTeams && window.microsoftTeams.pages && window.microsoftTeams.pages.isSupported()) {
                    const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
                    window.microsoftTeams.pages.navigateToApp({
                        appId: teamsAppId,
                        pageId: 'index' // Home tab entity ID
                    }).then(() => {
                        console.log('✅ Successfully navigated back to Home tab');
                    }).catch((error) => {
                        console.error('❌ Home tab navigation failed:', error);
                        navigate('/home');
                    });
                } else {
                    console.log('❌ Teams SDK not available, using React Router fallback');
                    navigate('/home');
                }
            } else {
                // 🔥 NEW FIX: Check if we came from Teams cross-tab navigation (no from param but has Teams context)
                // This happens when user clicks video from Home tab -> Video Catalogue -> Video Detail
                const checkTeamsContext = async () => {
                    try {
                        if (window.microsoftTeams && window.microsoftTeams.app) {
                            const context = await window.microsoftTeams.app.getContext();
                            
                            // Check if we have Teams subPageId parameters (indicates cross-tab navigation from Home)
                            if (context?.page?.subPageId && context.page.subPageId.includes('videoId=')) {
                                console.log('🔍 Teams context detected:', context.page.subPageId);
                                console.log('🏠 Cross-tab navigation detected: Video Detail -> Home tab (via Teams context)');
                                
                                // Clear the subPageId and navigate back to Home tab
                                const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
                                window.microsoftTeams.pages.navigateToApp({
                                    appId: teamsAppId,
                                    pageId: 'index', // Home tab entity ID
                                    subPageId: '' // Clear the subPageId to prevent loop
                                }).then(() => {
                                    console.log('✅ Successfully navigated back to Home tab (cleared subPageId)');
                                }).catch((error) => {
                                    console.error('❌ Home tab navigation failed:', error);
                                    navigate('/home');
                                });
                                return;
                            }
                        }
                        
                        // Default: navigate to Video Catalogue (same tab)
                        console.log('🔄 Default navigation: Video Detail -> Video Catalogue (no Teams context)');
                        navigate('/video-catalogue');
                        
                    } catch (error) {
                        console.error('❌ Teams context check failed:', error);
                        navigate('/video-catalogue');
                    }
                };
                
                checkTeamsContext();
            }
        } catch (error) {
            console.error('❌ Navigation error:', error);
            // Fallback to video catalogue
            navigate('/video-catalogue');
        }
    };

    useEffect(() => {
        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);
        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            // F12
            if (e.keyCode === 123) {
                e.preventDefault();
            }

            // Ctrl+Shift+I/J/C or Ctrl+U
            if (
                (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key)) ||
                (e.ctrlKey && e.key === 'U')
            ) {
                e.preventDefault();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);



    const handleNavigate = () => {
        navigate("/home")
    }


    if (detailLoading || relatedLoading || allVideoLoading || loading) {
        return <Loader />;
    }
    
    // 🔧 FIX: Only show error state when there's an actual error AND not loading
    // Prevent race condition where empty data triggers error before loading starts
    if (detailError && !detailLoading && !loading && userToken) {
        return (
            <div style={{ minHeight: "100vh" }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="whole-div">
                            <div className="row page-content">
                                <div className="col-12 text-center pt-5">
                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                        <a 
                                            onClick={userToken ? handleBackClick : handleNavigate}
                                            style={{
                                                cursor: 'pointer',
                                                fontWeight: 'bold',
                                                transition: 'color 0.2s ease',
                                                color: '#fff'
                                            }}
                                        >
                                            <i className="ri ri-arrow-left-s-line" style={{ fontWeight: 'bold' }}></i> {t('common.back')}
                                        </a>
                                    </div>
                                    <div className="card">
                                        <div className="card-body">
                                            <img src={oopsimg} alt="Video not found" style={{ maxWidth: '200px', opacity: 0.7 }} />
                                            <h3 className="mt-3 mb-2">{t('videoDetail.notFoundTitle')}</h3>
                                            <p className="text-muted mb-4">{t('videoDetail.notFoundText')}</p>
                                            <button 
                                                className="btn btn-primary" 
                                                onClick={userToken ? handleBackClick : handleNavigate}
                                            >
                                                {t('videoDetail.goBack')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div>
                {vdoDetail ? (
                    <>
                        <div style={{ minHeight: "100vh" }}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="whole-div">
                                        <div className="row page-content">

                                            <div className="row dash-nft">
                                                <div className="col-xl-12 col-md-12" style={{ paddingLeft: '0px' }}>
                                                    <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: '20px', paddingLeft: '0px', marginLeft: '0px' }}>
                                                        <div className="d-flex align-items-center top-icons gap-4" style={{ paddingLeft: '0px', marginLeft: '0px' }}>
                                                            <a 
                                                onClick={userToken ? handleBackClick : handleNavigate}
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold',
                                                    transition: 'color 0.2s ease',
                                                    color: '#fff'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.color = '#16f69f';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.color = '#fff';
                                                }}
                                            >
                                                <i className="ri ri-arrow-left-s-line" style={{ fontWeight: 'bold' }}></i> {t('common.back')}
                                            </a>
                                                            <p className="border-right" style={{ margin: '0 6px' }}></p>
                                                            <p style={{ cursor: "pointer", margin: 0, padding: 0 }}>
                                                                <a
                                                                    onClick={() => !bookMarkedStatus && handleToggleBookMark(vdoDetail?.id, vdoDetail?.isBookmark)}
                                                                    style={{
                                                                        cursor: bookMarkedStatus ? "not-allowed" : "pointer", 
                                                                        opacity: bookMarkedStatus ? 0.6 : 1,
                                                                        color: '#fff',
                                                                        textDecoration: 'none',
                                                                        fontWeight: 'bold',
                                                                        transition: 'color 0.2s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (!bookMarkedStatus) e.currentTarget.style.color = '#16f69f';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        if (!bookMarkedStatus) e.currentTarget.style.color = '#fff';
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={`mdi ${vdoDetail?.isBookmark ? "mdi-bookmark" : "mdi-bookmark-outline"} align-middle`}
                                                                        style={{ 
                                                                            color: vdoDetail?.isBookmark ? '#16f69f' : '#fff',
                                                                            fontSize: '18px',
                                                                            marginRight: '6px'
                                                                        }}
                                                                    ></i>
                                                                    <span style={{ color: '#fff' }}>{t('common.bookmark')}</span>
                                                                </a>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card card-radius">
                                                    <div className="card-body">
                                                        <div className="row">
                                            <div className="col-xl-6 col-md-6">
                                                <div
                                                    className="portfolio-card vdeo-detail-img"
                                                    onClick={handleShowModal}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <div className="portfolio-img img-shine">
                                                        <img
                                                            src={vdoDetail?.thumbnail}
                                                            className="video-img"
                                                            alt="Video Thumbnail"
                                                            style={{
                                                                width: "100%",
                                                                height: "auto",
                                                                display: "block",
                                                                borderRadius: "8px",
                                                                objectFit: "cover",
                                                            }}
                                                        />
                                                        <div className="portfolio-content">
                                                            <div className="play-btn style3 popup-youtube">
                                                                <i className="mdi mdi-play"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                                            <div className="col-xl-6 col-md-6">
                                                <div
                                                    className="flex-grow-1"
                                                    style={{ 
                                                        minWidth: 0, 
                                                        flexShrink: 1, 
                                                        display: "flex", 
                                                        flexDirection: "column", 
                                                        gap: "1rem",
                                                        height: "100%"
                                                    }}
                                                >
                                                    {/* Title and Category Section */}
                                                    <div
                                                        className="d-flex align-items-center justify-content-between"
                                                        style={{ flexWrap: "wrap" }}
                                                    >
                                                        <h2
                                                            className="lh-base video-detail mb-0 fw-bold"
                                                            style={{ wordBreak: "break-word", fontSize: "20px", flex: "1 1 auto" }}
                                                        >
                                                            {vdoDetail?.title}
                                                        </h2>
                                                        <div className="lifestyle-icon mb-0" style={{ marginLeft: "1rem", textAlign: "center" }}>
                                                            <img
                                                                src={
                                                                    vdoDetail?.category?.name === "NUTRITION"
                                                                        ? nutritionImg
                                                                        : vdoDetail?.category?.name === "LIFESTYLE"
                                                                            ? lifestleImg
                                                                            : vdoDetail?.category?.name === "TRAINING"
                                                                                ? trainingImg
                                                                                : ""
                                                                }
                                                                style={{ maxWidth: "40px", height: "auto", display: "block", margin: "0 auto" }}
                                                            />
                                                            <p className="mb-0" style={{ fontSize: "0.9rem" }}>
                                                                {i18n.language === 'en'
                                                                    ? vdoDetail?.category?.name.charAt(0).toUpperCase() + vdoDetail?.category?.name.slice(1).toLowerCase()
                                                                    : dbLabel(vdoDetail?.category?.name, i18n.language)}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Description Section - Scrollable with expanded height */}
                                                    <div
                                                        className="content-div-1"
                                                        style={{ 
                                                            wordBreak: "break-word", 
                                                            overflowWrap: "break-word", 
                                                            whiteSpace: "normal",
                                                            flex: "1",
                                                            overflowY: "auto",
                                                            maxHeight: "calc(100% - 140px)", // Reserve space for title and complete button
                                                            paddingRight: "10px"
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: sanitize(vdoDetail?.description) }}
                                                    />

                                                    {/* Mark Complete Section - Always at bottom */}
                                                    <div
                                                        className="complete-div"
                                                        style={{
                                                            backgroundColor: "#f8f9fa",
                                                            border: "1px solid #e0e0e0",
                                                            borderRadius: "8px",
                                                            padding: "10px",
                                                            marginTop: "1rem",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between" style={{ flexWrap: "wrap" }}>
                                                            <p style={{ margin: 0, fontSize: "0.95rem" }}>
                                                                {t('videoDetail.markCompleteHint')}
                                                            </p>
                                                            <button
                                                                className="btn btn-border"
                                                                disabled={disabled}
                                                                onClick={() =>
                                                                    vdoDetail?.isCompleted
                                                                        ? handleDeleteCompleted(vdoDetail?.id)
                                                                        : handleCompleted(vdoDetail?.id)
                                                                }
                                                            >
                                                                <i className="ri ri-checkbox-circle-line"></i>{" "}
                                                                {vdoDetail?.isCompleted ? t('videoDetail.completed') : t('videoDetail.markComplete')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row dash-nft">
                                                <div className="col-lg-12 p-0">
                                                    <div className="swiper marketplace-swiper rounded gallery-light">
                                                        <div className="d-flex gap-2 pt-4 pb-2">
                                                            <div className="w-100 d-flex justify-content-between align-items-center">
                                                                {relatedVideos?.length > 0 && (
                                                                    <h5 className="card-title mb-1 text-white ">{t('videoDetail.relatedVideos')}</h5>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            {relatedVideos?.map((video, index) => (
                                                                <div className="col-12 col-sm-6 col-lg-3 p-0" key={video?.id || index} >
                                                                    <div className="card explore-box card-animate">
                                                                        <div className="explore-place-bid-img"
                                                                            onClick={(e) => { handleRelatedVideo(video?.id, video?.category?.id) }}
                                                                        >
                                                                            <img
                                                                                src={video?.thumbnail}
                                                                                alt={video?.title || "Related video thumbnail"}
                                                                                className="img-fluid card-img-top explore-img"
                                                                                style={{ height: "200px", objectFit: "cover" }}
                                                                            />
                                                                            <div className="bg-overlay"></div>
                                                                            <div className="place-bid-btn">
                                                                                <a className="cursor-pointer">
                                                                                    <i className="ri-play-circle-fill align-bottom me-1"></i>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                <h6 className="card-title mb-0 flex-grow-1" 
                                                                                    style={{ 
                                                                                        cursor: "pointer", 
                                                                                        fontSize: "14px",
                                                                                        lineHeight: "1.2",
                                                                                        height: "17px",
                                                                                        overflow: "hidden",
                                                                                        whiteSpace: "nowrap",
                                                                                        textOverflow: "ellipsis"
                                                                                    }} 
                                                                                    onClick={(e) => { handleRelatedVideo(video?.id, video?.category?.id) }}>
                                                                                    <a className="text-primary">
                                                                                        {video?.title}
                                                                                    </a>
                                                                                </h6>
                                                                                <button
                                                                                    className="btn btn-sm p-0"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (bookmarkLoadingIds.includes(video.id)) return;
                                                                                        setBookmarkLoadingIds((prev) => [...prev, video.id]);
                                                                                        const bookmarkAction = video.isBookMarked ? handleDeleteBookMark : handleAddBookMark;
                                                                                        bookmarkAction(video.id).finally(() => {
                                                                                            setBookmarkLoadingIds((prev) => prev.filter((id) => id !== video.id));
                                                                                        });
                                                                                    }}
                                                                                    disabled={bookmarkLoadingIds.includes(video.id)}
                                                                                    style={{ background: "none", border: "none" }}
                                                                                >
                                                                                <i className={`mdi ${video.isBookMarked ? "mdi-bookmark" : "mdi-bookmark-outline"} fs-18`} 
                                                                                   style={{ 
                                                                                       color: video.isBookMarked ? '#16f69f' : '#fff',
                                                                                       fontSize: '18px'
                                                                                   }}></i>
                                                                                </button>
                                                                            </div>
                                                                            {video?.subCategory?.name && (
                                                                                <p className="text-muted mb-1">
                                                                                    <small>{dbLabel(video.subCategory.name, i18n.language)}</small>
                                                                                </p>
                                                                            )}
                                                                            {video?.duration && (
                                                                                <p className="text-muted mb-0">
                                                                                    <small><i className="ri-time-line me-1"></i>{video.duration}</small>
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={{ minHeight: "100vh" }}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="whole-div">
                                        <div className="row page-content">
                                            <div className="row dash-nft">
                                                <div className="col-lg-12">
                                                    <div className="swiper marketplace-swiper rounded gallery-light">
                                                        <div className="row">
                                                            {allVideos?.map((video, index) => (
                                                                <div className="col-12 col-sm-6 col-lg-3" key={video?.id || index} >
                                                                    <div className="card explore-box card-animate">
                                                                        <div className="explore-place-bid-img"
                                                                            onClick={(e) => { handleRelatedVideo(video?.id, video?.category?.id), handleTabSwitch(video) }}
                                                                        >
                                                                            <img
                                                                                src={video?.thumbnail}
                                                                                alt={video?.title || "Related video thumbnail"}
                                                                                className="img-fluid card-img-top explore-img"
                                                                                style={{ height: "200px", objectFit: "cover" }}
                                                                            />
                                                                            <div className="bg-overlay"></div>
                                                                            <div className="place-bid-btn">
                                                                                <a className="cursor-pointer">
                                                                                    <i className="ri-play-circle-fill align-bottom me-1"></i>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                <h6 className="card-title mb-0 flex-grow-1" 
                                                                                    style={{ 
                                                                                        cursor: "pointer", 
                                                                                        fontSize: "14px",
                                                                                        lineHeight: "1.2",
                                                                                        height: "17px",
                                                                                        overflow: "hidden",
                                                                                        whiteSpace: "nowrap",
                                                                                        textOverflow: "ellipsis"
                                                                                    }} 
                                                                                    onClick={(e) => { handleRelatedVideo(video?.id, video?.category?.id) }}>
                                                                                    <a className="text-primary">
                                                                                        {video?.title}
                                                                                    </a>
                                                                                </h6>
                                                                                <button
                                                                                    className="btn btn-sm p-0"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (bookmarkLoadingIds.includes(video?.id)) return;
                                                                                        setBookmarkLoadingIds((prev) => [...prev, video?.id]);
                                                                                        handleAddBookMarkAllVideos(video?.id).finally(() => {
                                                                                            setBookmarkLoadingIds((prev) => prev.filter((id) => id !== video?.id));
                                                                                        });
                                                                                    }}
                                                                                    disabled={bookmarkLoadingIds.includes(video?.id)}
                                                                                    style={{ background: "none", border: "none" }}
                                                                                >
                                                                                    <i className={`mdi ${BookMarkedTrueIds.includes(video?.id) ? "mdi-bookmark" : "mdi-bookmark-outline"} fs-18`} 
                                                                                       style={{ 
                                                                                           color: BookMarkedTrueIds.includes(video?.id) ? '#16f69f' : '#fff',
                                                                                           fontSize: '18px'
                                                                                       }}></i>
                                                                                </button>
                                                                            </div>
                                                                            {video?.subCategory?.name && (
                                                                                <p className="text-muted mb-1">
                                                                                    <small>{dbLabel(video.subCategory.name, i18n.language)}</small>
                                                                                </p>
                                                                            )}
                                                                            {video?.duration && (
                                                                                <p className="text-muted mb-0">
                                                                                    <small><i className="ri-time-line me-1"></i>{video.duration}</small>
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showModel && (
                    <div style={{ display: showModel ? "block" : "", backgroundColor: "#000000b8" }} className="modal bs-example-modal-center-top" tabIndex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "80vw", width: "80vw" }}>
                            <div className="modal-content" style={{ backgroundColor: "transparent", border: "none" }}>
                                <div className="modal-header" style={{ padding: "10px 15px", border: "none", backgroundColor: "transparent" }}>
                                    <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" onClick={(e) => { flushVideoProgress(); setShowModel(false); }} style={{ filter: "invert(1)", opacity: "1" }}></button>
                                </div>

                                <div className="modal-body text-center" style={{ padding: "0 15px 15px 15px" }}>
                                    <video
                                        ref={videoElRef}
                                        onTimeUpdate={handleVideoTimeUpdate}
                                        onEnded={handleVideoEnded}
                                        onPause={handleVideoTimeUpdate}
                                        src={vdoDetail?.url}
                                        title="Video player"
                                        controls
                                        autoPlay
                                        controlsList="nodownload"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        style={{ 
                                            width: "100%",
                                            height: "80vh",           // ✅ Increase from 55vh to 80vh (roughly doubles viewing area)
                                            minHeight: "600px",       // ✅ Higher minimum for small screens
                                            maxHeight: "90vh",        // ✅ Prevent overflow on very short screens
                                            borderRadius: "8px",
                                            objectFit: "contain"      // ✅ Maintains aspect ratio, no distortion
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default VideoDetail